
<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title class="d-flex justify-space-between">
          Bulk Asset Editor

          <div
            v-show="totalPages > 1"
            class="text-center p-t-10"
          >
            <v-pagination
              v-model="page"
              :length="totalPages"
              :total-visible="7"
            />
          </div>

          <v-btn
            color="primary"
            @click="saveAssets()"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Save
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <hot-table
                v-if="!loading && assets.length"
                :data="assets"
                :row-headers="true"
                :col-headers="true"
                :settings="hotSettings"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </base-card>
    </v-col>

    <v-dialog
      v-model="dialog"
      persistent
      inset
      max-width="960"
    >
      <v-card v-if="selectedAsset">
        <v-card-title>Asset #{{ selectedAsset.id }} state = {{ selectedAsset.state }}</v-card-title>
        <v-card-text>
          <iframe
            id="serviceFrameSend"
            :src="frameSrc"
            width="100%"
            height="380"
            frameborder="0"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  import { HotTable } from '@handsontable/vue'
  import { registerAllModules } from 'handsontable/registry'
  import 'handsontable/dist/handsontable.full.css'
  import { processAsset } from '@/store/converters'

  registerAllModules()

  export default {
    metaInfo: {
      title: 'Edit Distribution Package',
    },
    components: {
      HotTable,
    },
    data: () => ({
      dialog: false,
      selectedAsset: null,
      channel: {},
      hotSettings: {
        width: '100%',
        colHeaders: ['ID', 'Title', 'Description'],
        rowHeights: 35,
        manualColumnResize: true,
        height: 'auto',
        licenseKey: 'non-commercial-and-evaluation',
        columns: [
          {
            data: 'id',
            width: 70,
            readOnly: true,
          },
          {
            data: 'name',
            width: 400,
          },
          {
            data: 'description',
            width: 600,
          },
        ],
      },
      assets: [],
      frameSrc: '',
      limit: 20,
      offset: 0,
      total: 0,
      page: 1,
      originalById: {},
    }),
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      totalPages () {
        return Math.ceil(this.total / this.limit)
      },
    },
    watch: {
      // eslint-disable-next-line no-unused-vars
      page (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.page = newVal
          this.changeRoute()
          this.getAssets(false)
        }
      },
    },
    created () {
      this.channel.id = this.$route.params.id

      let page = Number(this.$route.query.page)
      if (!page) {
        page = 1
      }
      this.page = page

      this.getAssets()
    },
    mounted () {
      const vm = this
      this.hotSettings.afterOnCellMouseDown = (event, coords) => {
        if (coords.row >= 0 && coords.col === 0) {
          const asset = vm.assets?.[coords.row]
          if (asset) {
            vm.selectedAsset = asset
            this.openPlayer(asset.streams[0].streamURL)
            vm.dialog = true
          }
        }
      }
      this.$nextTick(() => {
        this.$refs.hot?.hotInstance?.updateSettings({
          afterOnCellMouseDown: this.hotSettings.afterOnCellMouseDown,
        })
      })
    },
    methods: {
      changeRoute () {
        const newQuery = {
          page: `${this.page}`,
        }
        this.$router.push({
          query: newQuery,
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
      },
      getAssets (silent = false) {
        if (!silent) this.$store.commit('setPageLoader')

        const assetArgs = {
          $expand: 'streams',
          $orderby: '-id',
          'type[eq]': 'movie',
          'channel.id[eq]': this.channel.id,
          $limit: this.limit,
          $offset: this.limit * this.page - this.limit,
        }

        const assetReq = this.$store.dispatch('assets', assetArgs)

        const assetCountArgs = {
          'type[eq]': 'movie',
          'channel.id[eq]': this.channel.id,
        }

        const assetCountReq = this.$store.dispatch('assetCount', assetCountArgs)

        // eslint-disable-next-line consistent-return,max-len
        return Promise.all([assetReq, assetCountReq])
          .then((res) => {
            const assets = res[0]
            this.assets = assets.map((a) => processAsset(a))

            const map = {}
            for (const a of this.assets) {
              map[a.id] = { name: a.name ?? '', description: a.description ?? '' }
            }
            this.originalById = map

            this.total = res[1]
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      saveAssets () {
        this.$store.commit('setPageLoader')

        const requests = []

        for (const a of this.assets) {
          const orig = this.originalById[a.id] || {}
          if (!orig) continue
          if (orig.name !== a.name || orig.description !== a.description) {
            requests.push(this.$store.dispatch('updateAsset', { id: a.id, name: a.name, description: a.description }))
          }
        }

        return Promise.all(requests)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Assets have been successfully updated',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
      openPlayer (stream) {
        this.setFrameSrc(stream)
      },
      setFrameSrc (url) {
        const link = url.replace(/^http:\/\//, 'https://')
        this.frameSrc = `/js/radiant/index2.html?src=${link}`
      },
      closePlayer () {
        this.dialog = false
        this.setFrameSrc('')
      },
    },
  }
</script>

<style>
</style>
